// Mock data for the Divine Anointing landing page

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Wedding Couple",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b5bc?w=150&h=150&fit=crop&crop=face",
    content: "Nadja Scott and the Divine Anointing choir made our wedding ceremony absolutely magical. Their voices filled the church with such beautiful spirit and love. Every guest was moved to tears.",
    rating: 5,
    event: "Wedding Ceremony"
  },
  {
    id: 2,
    name: "Pastor Michael Chen",
    role: "Lead Pastor",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    content: "Divine Anointing's performance at our church revival was absolutely incredible. The spiritual energy and powerful voices brought our congregation to tears of joy.",
    rating: 5,
    event: "Church Revival"
  },
  {
    id: 3,
    name: "Maria Rodriguez",
    role: "Event Coordinator", 
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    content: "Professional, punctual, and absolutely phenomenal! Nadja's choir brought such energy and spiritual presence to our corporate event. Highly recommend for any occasion.",
    rating: 5,
    event: "Corporate Event"
  },
  {
    id: 4,
    name: "James Washington",
    role: "Choir Director",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face", 
    content: "As a fellow choir director, I was amazed by their professionalism and musical excellence. Nadja Scott's leadership and the choir's harmony created an unforgettable worship experience.",
    rating: 5,
    event: "Musical Collaboration"
  },
  {
    id: 5,
    name: "Nadja Scott",
    role: "Lead Artist & Director",
    image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/qq8te3p2_IMG_8832.jpeg", 
    content: "Divine Anointing is more than just music - it's a calling to touch hearts and transform lives through the power of worship. Every performance is a spiritual journey.",
    rating: 5,
    event: "Founder's Message"
  }
];

export const bookingOptions = [
  {
    id: 'choir-performance',
    title: 'Choir Performance',
    description: 'Full choir performance for your special event',
    pricing: 'Starting at $800',
    duration: '2-3 hours',
    includes: ['10-15 choir members', 'Professional sound equipment', 'Song selection consultation', 'Rehearsal coordination']
  },
  {
    id: 'church-events',
    title: 'Church Event Bookings', 
    description: 'Complete musical direction for church gatherings',
    pricing: 'Custom pricing',
    duration: 'Varies by event',
    includes: ['Event coordination', 'Musical direction', 'Choir arrangement', 'Technical support']
  }
];

// Platform features removed - we don't offer choir management software

export const chatResponses = {
  greeting: "Hello! Welcome to Divine Anointing. How can I help you today?",
  booking: "I'd be happy to help you with booking! For all booking requests, please contact Manager Joseph Johnson at Elite Complex: 202-704-4758 or theelitecomplex@gmail.com",
  pricing: "Our pricing varies by service. For detailed quotes and availability, please contact Manager Joseph Johnson at Elite Complex: 202-704-4758 or theelitecomplex@gmail.com",
  availability: "For availability and scheduling, please contact Manager Joseph Johnson at Elite Complex: Phone: 202-704-4758 | Email: theelitecomplex@gmail.com",
  services: "We offer choir performances for events and complete church event coordination. Contact Manager Joseph Johnson at Elite Complex for more details: 202-704-4758",
  default: "Thank you for your message! For bookings and inquiries, please contact Manager Joseph Johnson at Elite Complex: 202-704-4758 or theelitecomplex@gmail.com"
};